// extracted by mini-css-extract-plugin
export var pollQuestionAnswersSlot = "PollQuestion-module--pollQuestionAnswersSlot--59c44";
export var pollQuestionHeaderSlot = "PollQuestion-module--pollQuestionHeaderSlot--838f4";